import React from 'react';
import { OccurrenceDetail } from '../../components/occurrence/OccurrenceDetail';
import { RouteProp, useRoute } from '@react-navigation/native';
import { DispatchParamList } from '../../typings/Params';
import { RootNavigation } from '../../Routes';


interface DispatchOccurrenceDetailParams {
    navigation: RootNavigation;
}

export default function DispatchOccurrenceDetail({ navigation }: DispatchOccurrenceDetailParams) {
    const route = useRoute<RouteProp<DispatchParamList, 'DispatchOccurrenceDetail'>>();
    return (
        <OccurrenceDetail navigation={navigation} occurrenceId={route.params?.occurrenceId} page={'dispatch'} />
    );
}
